export default {
    email: 'Email',
    phone: 'Phone',
    sms: 'SMS',
};
